import styled from 'styled-components';

import { colorWhite } from 'styles/variables';

export const Header = styled.div`
  position: sticky;
  top: 0;
  background: ${colorWhite};
  z-index: 3000000002;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
`;

export const CloseButton = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  width: 16px;
  background: transparent;
  padding: 0;
  border: 0;

  &:after {
    content: '';
    position: absolute;
    top: -16px;
    bottom: -16px;
    left: -16px;
    right: -16px;
    z-index: 1;
  }
`;

export const Title = styled.h4`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
`;
